import {connect} from "redux-vue";
import SlideTemplate from "./SlideTemplate";
import * as appActions from "../actions/app";
import * as actionActions from "../actions/action";
import * as actionsActions from "../actions/actions";
import {findLastIndex} from "../../helpers/tools";
import {resetScrollConfig, testStakeholderIsStaff} from "../helpers/tools";
import {ANY_STAKEHOLDER_WITH_MOTIVATION_LESS_THAN_60} from "../factories/actions";
import {WEEKS_TARGET} from "../helpers/consts";
import {limit} from "../helpers/tools";

const TakeActionSlide = {
  props: ['goTo', 'fetchActions', 'actions', 'setAction', 'notifications', 'locations', 'reset'],

  data() {
    return {
      showComplete: true,
    }
  },

  mounted() {
    this.fetchActions();
    tippy('[data-tippy-content]', {
      placement: 'bottom'
    });
  },

  watch: {
    'actions.history'(val, prev) {
      if (val.length !== prev.length) {
        this.fetchActions();
      }
    },
  },
  computed: {

    /**
     *
     * @returns {*}
     */
    weeksRemaining() {
      const progress = this.actions.history
        .reduce((a, b) => a + b.weeks_required, 1);
      return limit(WEEKS_TARGET-progress, 0, WEEKS_TARGET);
    },
  },
  methods: {
    /**
     *
     * @param action
     * @returns {Function}
     */
    handleTakeAction(action) {
      return () => {
        this.setAction(action);
      }
    },

    /**
     *
     */
    toggleComplete() {
      this.showComplete = !this.showComplete;
      resetScrollConfig();
    },

    /**
     *
     * @param action
     * @returns {boolean}
     */
    isCompleted(action) {
      const foundIndex = findLastIndex(this.actions.history, 'id', action.id);
      if (foundIndex >= 0 && action.repeat_in_weeks) {
        const weeksAfter = this.actions.history
          .slice(foundIndex + 1)
          .reduce((x, y) => x + y.weeks_required, 0);
        return weeksAfter < action.repeat_in_weeks;
      } else if (foundIndex >= 0) {
        return true;
      }
      return false;
    },

    /**
     *
     * @param action
     * @returns {boolean}
     */
    isNew(action) {
      return this.notifications.collection.findIndex(each => each.id === action.id && each.type === 'Action') >= 0;
    },

    /**
     *
     * @param action
     * @returns {string}
     */
    makeAvailableText(action) {
      const foundIndex = findLastIndex(this.actions.history, 'id', action.id);
      if (foundIndex >= 0) {
        let weeksElapsed = this.actions.history.slice(foundIndex + 1)
          .reduce((a, b) => a + b.weeks_required, 0);
        weeksElapsed = action.repeat_in_weeks - weeksElapsed;
        return `Available Again In ${weeksElapsed} ${weeksElapsed === 1 ? 'Week' : 'Weeks'}`
      }
    },

    /**
     *
     */
    handleReset() {
      if (
        window.confirm(`Are you sure?  This will wipe out all of your progress.`)
      ) {
        this.reset();
        }
      }
    },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const helpTip = (
      <span data-tippy-content="The number of weeks required to plan and then to take this action. In some situations, the number of weeks may seem longer than expected. However, since your change management team has other responsibilities, they cannot spend all of their time on just this project.">
        <i class="mdi mdi-help-circle text-brand-orange-700"></i>
      </span>
    );
    const uncompletedAndRepeatableCollection = this.actions.collection
      .filter(each => (each.weeks_required <= this.weeksRemaining))
      .filter(each => (each.repeat_in_weeks || this.actions.history.findIndex(i => i.id === each.id) < 0))
      .filter(each => {
        if (each.targeted === ANY_STAKEHOLDER_WITH_MOTIVATION_LESS_THAN_60) {
          return this.locations.collection
            .map(each =>
              each.stakeholders.filter(testStakeholderIsStaff).filter(i => i.motivation < 60)
            )
            .reduce((a, b) => a.concat(b), [])
            .length > 0;
        }
        return true;
      });
    return (
      <SlideTemplate key={this.showComplete.toString() + this.actions.collection.length}>
        <div class="p-6 py-10 lg:px-24">

          <p class="text-sm text-brand-gray-500 transform -translate-y-5 leading-none">
            <strong class="mr-1">Take Action</strong>
            <small>
              (Select the Take Action button beside the action that you want to take now. Selecting some actions will
              reveal additional, follow-up actions.)
            </small>
          </p>

          <div class="lg:flex items-center p-3 hidden">
            <div class="w-4/6 font-bold text-lg">
              Action
            </div>
            <div class="w-2/6 font-bold text-lg">
              Time Required
              {helpTip}
            </div>
          </div>

          <ul class="border-b border-gray-500 leading-tight mb-5">
            {uncompletedAndRepeatableCollection.map(i => (
              <li key={i.id} class="border-t border-gray-500 p-3 flex lg:items-center flex-col lg:flex-row">
                <div class="w-full lg:w-4/6">
                  <p class="lg:hidden font-bold leading-loose">
                    Action
                  </p>
                  <p class="lg:w-5/6">
                    {i.action}
                  </p>
                </div>
                <div class="w-full lg:w-2/6">
                  <div class="flex flex-col lg:flex-row lg:items-center">
                    <div class="w-full lg:w-1/2 my-3 lg:m-0">
                      <p class="lg:hidden font-bold leading-loose">
                        Time Required
                        {helpTip}
                      </p>
                      <p>
                        {i.weeks_required} {i.weeks_required === 1 ? 'week' : 'weeks'}
                      </p>
                    </div>
                    <div class="w-full lg:w-1/2 flex items-center justify-between">
                      {this.isCompleted(i) && (
                        <fragment>
                          {Boolean(i.repeat_in_weeks) && (
                            <p class="lg:px-2">
                              {this.makeAvailableText(i)}
                            </p>
                          )}
                          {Boolean(i.repeat_in_weeks) || (
                            <p class="lg:px-5">
                              Completed
                            </p>
                          )}
                          <img src="/img/changemanagement/icn-gear.svg" alt="" class="w-5 ml-4 lg:mx-auto"/>
                        </fragment>
                      )}
                      {this.isCompleted(i) || (
                        <fragment>
                          <button type="button" onClick={this.handleTakeAction(i)}
                                  class="whitespace-no-wrap rounded-full bg-brand-orange-700 text-white uppercase p-2 px-4 text-sm hover:bg-orange-700 focus:outline-none">
                            Take Action
                          </button>
                          {this.isNew(i) && (
                            <div class="w-5 h-5 ml-4 lg:mx-auto" data-tippy-content="Unlocked action">
                              <img src="/img/changemanagement/new-badge.svg" alt="NEW" class="w-full h-full"/>
                            </div>
                          )}
                          {!this.isNew(i) && i.targeted && (
                            <img src="/img/changemanagement/icn-target.svg" alt="" class="w-5 ml-4 lg:mx-auto"/>
                          )}
                          {!this.isNew(i) && !i.targeted && i.repeat_in_weeks && (
                            <img src="/img/changemanagement/icn-cycle.svg" alt="" class="w-5 ml-4 lg:mx-auto"/>
                          )}
                        </fragment>
                      )}
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>

          {this.actions.history.length > 0 && (
            <div onClick={this.toggleComplete} class="cursor-pointer w-full bg-brand-gray-500 h-10 mb-5">
              <div class="font-bold flex items-center justify-center text-white lg:text-lg transform -translate-y-2">
                Completed Actions
                <i class={"mdi text-5xl leading-none -ml-2 " + (this.showComplete ? "mdi-menu-down": "mdi-menu-up")}></i>
                <small class="font-normal text-xs">
                  (Toggle View)
                </small>
              </div>
            </div>
          )}

          {this.actions.history.length > 0 && this.showComplete && (
            <ul class="border-b border-gray-500 leading-tight text-brand-gray-500">
              {this.actions.history.map((i, index) => (
                <li key={i.id+index} class="border-t border-gray-500 p-3 flex lg:items-center flex-col lg:flex-row">
                  <div class="w-full lg:w-4/6">
                    <p class="lg:hidden font-bold leading-loose">
                      Action
                    </p>
                    <p class="lg:w-5/6">
                      {i.action}
                    </p>
                  </div>
                  <div class="w-full lg:w-2/6">
                    <div class="flex flex-col lg:flex-row lg:items-center">
                      <div class="w-full lg:w-1/2 my-3 lg:m-0">
                        <p class="lg:hidden font-bold leading-loose">
                          Time Required
                        </p>
                        <p>
                          {i.weeks_required} {i.weeks_required === 1 ? 'week' : 'weeks'}
                        </p>
                      </div>
                      <div class="w-full lg:w-1/2 flex items-center">
                        <p class="lg:px-5">
                          Completed
                        </p>
                        <i class="mdi mdi-check-circle-outline text-brand-gray-500 ml-4 lg:mx-auto text-xl"></i>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
              <li>
                 <button type="button" onClick={this.handleReset}
                      class="underline">
                      Reset Simulation
              </button>
              </li>
            </ul>
          )}
        </div>
       
      </SlideTemplate>
    )
  }
};

function mapStateToProps(state) {
  return {
    actions: state.simulation.actions,
    locations: state.simulation.locations,
    notifications: state.simulation.notifications,
  };
}

function mapActionToProps(dispatch) {
  return {
    goTo: (slide) => dispatch(appActions.goTo(slide)),
    fetchActions: () => dispatch(actionsActions.fetchActions()),
    setAction: (action) => dispatch(actionActions.setAction(action)),
    reset: () => dispatch(appActions.reset()),
  };
}

export default connect(mapStateToProps, mapActionToProps)(TakeActionSlide);
